import { useState } from "react";
import type { Lead } from "../../types.ts";
import { getLeadCentralCampaign } from "../kanban/leadCampaign.ts";

type KanbanLeadCardProps = {
  lead: Lead | null;
  funnelTitle?: string;
  stageTitle?: string;
};

function fieldValue(value: unknown): string {
  return String(value || "").trim();
}

export function KanbanLeadCard({ lead, funnelTitle = "", stageTitle = "" }: KanbanLeadCardProps) {
  const [expanded, setExpanded] = useState(false);
  if (!lead) return null;

  const name = fieldValue(lead.name) || fieldValue(lead.email) || fieldValue(lead.phone) || "Lead";
  const notes = fieldValue(lead.notes);
  const centralCampaign = getLeadCentralCampaign(lead);
  const fields = [
    ["Campanha", centralCampaign?.label],
    ["Telefone", lead.phone],
    ["Email", lead.email],
    ["Curso", lead.course],
    ["Funil", funnelTitle],
    ["Etapa", stageTitle || lead.stage],
    ["Prioridade", lead.priority],
  ].map(([label, value]) => [String(label), fieldValue(value)] as const)
    .filter(([, value]) => value);

  return (
    <div className={`central-lead-card kanban-lead-card ${expanded ? "is-expanded" : ""}`}>
      <header className="central-lead-head">
        <div className="central-lead-title">
          <span className="central-lead-status" style={{ background: "#108b7c" }}>Kanban</span>
          <strong className="central-lead-name">{name}</strong>
        </div>
        {notes ? (
          <button
            type="button"
            className="central-lead-toggle"
            onClick={() => setExpanded((value) => !value)}
            aria-label={expanded ? "Recolher dados do lead" : "Expandir dados do lead"}
          >
            {expanded ? "Recolher" : "Mais dados"}
          </button>
        ) : null}
      </header>

      <div className="central-lead-grid">
        {fields.slice(0, 6).map(([label, value]) => (
          <div className="central-lead-cell" key={label}>
            <span className="central-lead-label">{label}</span>
            <span className="central-lead-value">{value}</span>
          </div>
        ))}
      </div>

      {expanded && notes ? (
        <div className="central-lead-expanded">
          <div className="central-lead-section">
            <h4 className="central-lead-section-title">Notas</h4>
            <p className="central-lead-value">{notes}</p>
          </div>
        </div>
      ) : null}
    </div>
  );
}
